module.exports = __webpack_public_path__ + "img/outdoor.99a93760.svg";